import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Skeleton } from "../../components/ui/skeleton";
import AdminPageHeader from "../../components/admin/AdminPageHeader";
import EmailStatusCard from "../../components/admin/EmailStatusCard";
import SendingDomainCard from "../../components/admin/SendingDomainCard";
import FormSettingsCard from "../../components/admin/FormSettingsCard";
import { errorMessage, formsApi } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

const FormSettings = () => {
  const { isMaster } = useAuth();
  const [settings, setSettings] = useState(null);
  const [status, setStatus] = useState(null);

  const loadStatus = useCallback(() => formsApi.emailStatus().then(setStatus).catch((err) => toast.error(errorMessage(err, "Could not load email status"))), []);

  useEffect(() => {
    formsApi
      .settings()
      .then(setSettings)
      .catch((err) => {
        toast.error(errorMessage(err, "Could not load form settings"));
        setSettings([]);
      });
    loadStatus();
  }, [loadStatus]);

  return (
    <div className="space-y-8" data-testid="form-settings-page">
      <AdminPageHeader
        crumbs={[{ label: "Forms & Email" }]}
        eyebrow="Routing"
        title="Forms & Email"
        description="Decide where each form's submissions are sent and what the automatic follow-up says. Every submission is also kept in the Submissions inbox."
      />

      <EmailStatusCard status={status} />
      {isMaster && <SendingDomainCard status={status} onRefresh={loadStatus} />}

      {settings === null ? (
        <div className="space-y-6">
          {["a", "b", "c"].map((k) => (
            <Skeleton key={k} className="h-72" />
          ))}
        </div>
      ) : (
        <div className="space-y-8">
          {settings.map((s) => (
            <FormSettingsCard key={s.form_type} settings={s} onSaved={(saved) => setSettings((prev) => prev.map((x) => (x.form_type === saved.form_type ? saved : x)))} />
          ))}
        </div>
      )}
    </div>
  );
};

export default FormSettings;
